// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalNetworkOperationTaskStatusSchema = z.enum(['PENDING','DISPATCHED','RUNNING','COMPLETED','FAILED','STOPPED','CANCELLED'] as const);

export type InternalNetworkOperationTaskStatusType = `${z.infer<typeof InternalNetworkOperationTaskStatusSchema>}`

export default InternalNetworkOperationTaskStatusSchema;
